"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSupplyChangeStatus = void 0;
const Base_1 = require("./Base");
exports.PostSupplyChangeStatus = {
    url: Base_1.URL_BASE + "/SupplyChangeStatus",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSupplyChangeStatus.js.map